"use client";
import { VisualizeSpecialData } from "@/types/common";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

import { formatYAxisTick } from "./chartAxis";

const CHART_MARGIN = { top: 10, right: 14, left: 10, bottom: 8 } as const;

export const LineChartComponent: React.FC<VisualizeSpecialData> = ({ data, title ,yAxisLabel}) => {
  return (
    <div className="p-4 bg-white shadow-lg rounded-lg overflow-hidden">
      <h2 className="text-lg font-semibold mb-4 max-w-full break-words leading-snug pr-1">{title}</h2>
      <ResponsiveContainer width="100%" height={300} className="min-h-[300px]">
        <LineChart data={data} margin={CHART_MARGIN}>
          <XAxis dataKey="name" tickMargin={8} />
          <YAxis
            width={100}
            tickMargin={10}
            tickFormatter={formatYAxisTick}
            tick={{ fontSize: 12 }}
            domain={["auto", "auto"]}
          />
          <Tooltip formatter={value => [value, yAxisLabel || "Value"]} />
          <Line
            type="linear"
            dataKey="point"
            stroke="#FF0000"
            strokeWidth={3}
            dot={{ r: 4, fill: "#FF0000", stroke: "#FF0000" }}
            activeDot={{ r: 5 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChartComponent;
